import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import InformationManagement from './components/InformationManagement';

const CommunityInformationManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="社區資訊管理"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '社區資訊管理',
            },
          ]}
        />
        <InformationManagement />
      </Col>
    </Row>
  );
};

export default CommunityInformationManagement;
